var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPandaSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "816.475875px",
    height: "900.854903px",
    viewBox: "0 0 816.475875 900.854903",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "panda") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M98.8187039,148.407721 C171.618704,181.907721 258.918704,139.507721 250.118704,63.1077208 C241.318704,-13.3922792 105.418704,72.6077208 88.6187039,57.9077208 C71.8187039,43.2077208 18.5187039,-23.9922792 3.3187039,9.00772082 C-11.8812961,42.0077208 26.0187039,114.907721 98.8187039,148.407721 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.825420623,2.01254894 C0.525420623,4.91254894 0.125420623,9.51254894 0.025420623,15.2125489 C-0.174579377,26.6125489 0.825420623,31.3125489 2.32542062,50.0125489 C3.02542062,59.0125489 3.92542062,68.1125489 4.62542062,77.1125489 C5.52542062,88.6125489 5.92542062,93.1125489 9.22542062,98.0125489 C10.4254206,99.7125489 15.6254206,106.712549 24.7254206,108.112549 C34.4254206,109.512549 43.6254206,104.112549 47.9254206,97.3125489 C50.1254206,93.7125489 50.6254206,90.4125489 50.6254206,76.2125489 C50.7254206,57.8125489 50.2254206,48.6125489 50.2254206,48.6125489 C48.3254206,13.2125489 48.0254206,11.7125489 46.4254206,9.51254894 C36.9254206,-3.58745106 11.2254206,0.0125489423 0.825420623,2.01254894 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8943515,63.5079778 C16.1943515,79.7079778 9.3943515,95.6079778 6.5943515,108.107978 C-0.00564849772,136.907978 -1.8056485,159.607978 1.8943515,186.007978 C1.8943515,186.007978 -0.00564849772,222.407978 33.1943515,256.407978 C40.9943515,264.407978 60.4943515,276.907978 60.4943515,276.907978 C68.4943515,281.307978 70.4943515,280.007978 75.5943515,283.107978 C84.9943515,288.707978 83.4943515,296.107978 94.7943515,314.707978 C104.394352,330.407978 111.294352,334.807978 113.294352,336.007978 C117.494352,338.507978 124.294352,342.507978 131.794352,340.807978 C145.194352,337.807978 150.094352,319.007978 150.994352,314.707978 C153.994352,301.307978 150.294352,290.007978 148.894352,285.207978 C142.894352,264.807978 148.894352,261.907978 150.294352,205.507978 C151.094352,174.107978 149.794352,149.807978 148.194352,119.007978 C145.994352,75.8079778 144.194352,77.2079778 144.794352,56.5079778 C145.694352,24.8079778 149.894352,16.9079778 143.394352,9.10797779 C129.594352,-7.29202221 86.1943515,-0.292022209 59.5943515,20.1079778 C41.9943515,33.8079778 30.6943515,49.3079778 23.8943515,63.5079778 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8943515,63.5079778 C16.1943515,79.7079778 9.3943515,95.6079778 6.5943515,108.107978 C-0.00564849772,136.907978 -1.8056485,159.607978 1.8943515,186.007978 C1.8943515,186.007978 -0.00564849772,222.407978 33.1943515,256.407978 C40.9943515,264.407978 60.4943515,276.907978 60.4943515,276.907978 C68.4943515,281.307978 70.4943515,280.007978 75.5943515,283.107978 C84.9943515,288.707978 83.4943515,296.107978 94.7943515,314.707978 C104.394352,330.407978 111.294352,334.807978 113.294352,336.007978 C117.494352,338.507978 124.294352,342.507978 131.794352,340.807978 C145.194352,337.807978 150.094352,319.007978 150.994352,314.707978 C153.994352,301.307978 150.294352,290.007978 148.894352,285.207978 C142.894352,264.807978 148.894352,261.907978 150.294352,205.507978 C151.094352,174.107978 149.794352,149.807978 148.194352,119.007978 C145.994352,75.8079778 144.194352,77.2079778 144.794352,56.5079778 C145.694352,24.8079778 149.894352,16.9079778 143.394352,9.10797779 C129.594352,-7.29202221 86.1943515,-0.292022209 59.5943515,20.1079778 C41.9943515,33.8079778 30.6943515,49.3079778 23.8943515,63.5079778 Z",
    id: "path-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "panda",
    transform: "translate(-201.6526, -95.5196)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 997,
    height: 979
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.434002,914.206228 C755.982912,937.142766 889.791269,772.316462 913.503913,581.355274 C937.216557,390.394081 824.94523,218.655739 619.545175,218.63765 C414.14512,218.619566 325.621516,365.847261 325.634146,549.47103 C325.646782,733.094799 428.885096,891.269691 592.434002,914.206228 Z",
    id: "Oval",
    fill: "#007674",
    fillRule: "nonzero",
    opacity: 0.3,
    transform: "translate(621.1341, 567.4918) rotate(20) translate(-621.1341, -567.4918)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "tail",
    transform: "translate(612.6021, 580.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0, -0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E6682E",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40.1603, -13.1111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-Clipped",
    transform: "translate(0, -0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.2790196,133.718847 C68.8790196,128.118847 71.3790196,83.3188471 94.1790196,62.2188471 C116.97902,41.1188471 140.77902,35.7188471 129.47902,30.5188471 C115.47902,24.1188471 73.2790196,-0.78115287 63.0790196,0.01884713 C38.9790196,1.81884713 18.6790196,25.4188471 11.4790196,37.8188471 C3.67901956,51.1188471 -3.42098044,85.9188471 1.77901956,98.5188471 C10.6790196,119.918847 54.7790196,138.518847 61.2790196,133.718847 Z",
    id: "Path",
    fill: "#AB340A",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_00000060004695687640848390000012293265608858665391_-Clipped",
    transform: "translate(111.3198, 43.9932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.5592079,146.425645 C92.2592079,139.225645 52.0592079,72.7256454 55.5592079,47.0256454 C59.0592079,21.3256454 71.1592079,4.0256454 63.8592079,2.0256454 C54.7592079,-0.474354597 36.1592079,-0.974354597 31.4592079,2.3256454 C20.4592079,10.2256454 6.85920789,29.5256454 2.65920789,60.6256454 C-1.54079211,91.6256454 -1.34079211,125.925645 7.45920789,132.625645 C25.7592079,146.525645 89.1592079,152.625645 90.5592079,146.425645 Z",
    id: "Path_00000060004695687640848390000012293265608858665391_",
    fill: "#AB340A",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_00000097485388787365357060000007430327847940849339_-Clipped",
    transform: "translate(216.3908, 29.0205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.9882332,116.198332 C96.6882332,108.998332 90.9882332,62.2983315 94.4882332,36.5983315 C97.9882332,10.8983315 61.8882332,3.69833151 54.6882332,1.69833151 C45.5882332,-0.801668487 29.3882332,-0.601668487 24.7882332,2.69833151 C13.7882332,10.5983315 -8.21176677,18.1983315 3.18823323,66.4983315 C14.5882332,114.798332 45.5882332,133.398332 52.5882332,143.898332 C64.3882332,161.798332 93.5882332,122.398332 94.9882332,116.198332 Z",
    id: "Path_00000097485388787365357060000007430327847940849339_",
    fill: "#AB340A",
    fillRule: "nonzero"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "left-leg",
    transform: "translate(530.0954, 656.0172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.825420623,2.01254894 C0.525420623,4.91254894 0.125420623,9.51254894 0.025420623,15.2125489 C-0.174579377,26.6125489 0.825420623,31.3125489 2.32542062,50.0125489 C3.02542062,59.0125489 3.92542062,68.1125489 4.62542062,77.1125489 C5.52542062,88.6125489 5.92542062,93.1125489 9.22542062,98.0125489 C10.4254206,99.7125489 15.6254206,106.712549 24.7254206,108.112549 C34.4254206,109.512549 43.6254206,104.112549 47.9254206,97.3125489 C50.1254206,93.7125489 50.6254206,90.4125489 50.6254206,76.2125489 C50.7254206,57.8125489 50.2254206,48.6125489 50.2254206,48.6125489 C48.3254206,13.2125489 48.0254206,11.7125489 46.4254206,9.51254894 C36.9254206,-3.58745106 11.2254206,0.0125489423 0.825420623,2.01254894 Z",
    id: "Path",
    fill: "#DF6B2A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.27457938,81.2125489 C-4.57457938,73.8125489 7.92542062,72.5125489 18.5254206,71.4125489 C26.9254206,70.5125489 33.3254206,71.4125489 39.3254206,72.2125489 C55.3254206,74.5125489 64.5254206,75.8125489 68.2254206,82.4125489 C72.4254206,89.9125489 67.8254206,101.112549 62.7254206,107.512549 C50.9254206,121.912549 25.7254206,123.912549 9.22542062,113.412549 C-2.67457938,106.012549 -12.7745794,90.3125489 -8.27457938,81.2125489 Z",
    id: "Path",
    fill: "#6F1703",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "left-hand",
    transform: "translate(466.0788, 533.0973)",
    fill: "#6F1703",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7,5.30268928 C40.1,13.3026893 40.4,21.4026893 27.9,41.3026893 C19.1,55.3026893 14.5,58.3026893 13.6,67.8026893 C13.3,71.0026893 12.4,79.8026893 17.7,85.5026893 C25.8,94.3026893 45,92.0026893 56.5,83.5026893 C69.5,73.7026893 70.6,57.2026893 72.1,34.5026893 C72.8,23.4026893 74.2,3.90268928 66,0.502689282 C61.3,-1.39731072 55.7,2.50268928 51.7,5.30268928 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "body",
    transform: "translate(500.2844, 429.1739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8943515,63.5260778 C16.1943515,79.7260778 9.3943515,95.6260778 6.5943515,108.126078 C-0.00564849772,136.926078 -1.8056485,159.626078 1.8943515,186.026078 C1.8943515,186.026078 -0.00564849772,222.426078 33.1943515,256.426078 C40.9943515,264.426078 60.4943515,276.926078 60.4943515,276.926078 C68.4943515,281.326078 70.4943515,280.026078 75.5943515,283.126078 C84.9943515,288.726078 83.4943515,296.126078 94.7943515,314.726078 C104.394352,330.426078 111.294352,334.826078 113.294352,336.026078 C117.494352,338.526078 124.294352,342.526078 131.794352,340.826078 C145.194352,337.826078 150.094352,319.026078 150.994352,314.726078 C153.994352,301.326078 150.294352,290.026078 148.894352,285.226078 C142.894352,264.826078 148.894352,261.926078 150.294352,205.526078 C151.094352,174.126078 149.794352,149.826078 148.194352,119.026078 C145.994352,75.8260778 144.194352,77.2260778 144.794352,56.5260778 C145.694352,24.8260778 149.894352,16.9260778 143.394352,9.12607779 C129.594352,-7.27392221 86.1943515,-0.273922209 59.5943515,20.1260778 C41.9943515,33.8260778 30.6943515,49.3260778 23.8943515,63.5260778 Z",
    id: "Path",
    fill: "#DF6B2A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(0.0705, 0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000096042169185027591680000012633701448669110179_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.1056485,77.4079778 C-7.7056485,83.2079778 -15.1056485,91.8079778 -21.8056485,103.307978 C-24.3056485,107.707978 -58.5056485,168.907978 -30.1056485,222.707978 C-23.6056485,235.007978 -5.0056485,249.207978 32.1943515,277.707978 C46.9943515,289.007978 55.9943515,294.807978 66.4943515,293.307978 C82.7943515,290.907978 92.1943515,272.207978 98.6943515,259.007978 C105.394352,245.307978 132.794352,184.307978 102.894352,123.007978 C95.5943515,108.207978 86.3943515,89.2079778 64.4943515,78.4079778 C34.8943515,63.8079778 4.6943515,74.7079778 -2.1056485,77.4079778 Z",
    id: "Path",
    fill: "#FEEFDE",
    fillRule: "nonzero",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval_00000044156855457829723480000002554297649168912287_-Clipped",
    transform: "translate(0.0705, 0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000096042169185027591680000012633701448669110179_"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_00000044156855457829723480000002554297649168912287_",
    fill: "#6F1703",
    fillRule: "nonzero",
    mask: "url(#mask-8)",
    cx: 128.694352,
    cy: 318.007978,
    rx: 47.9,
    ry: 30
  }))), /*#__PURE__*/React.createElement("g", {
    id: "left-ear",
    transform: "translate(516.2796, 304.7914) rotate(-104) translate(-516.2796, -304.7914)translate(481.6475, 270.0431)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7653551,50.8811873 C51.1653551,44.1811873 65.0653551,15.6811873 62.0653551,10.6811873 C59.0653551,5.68118729 32.3653551,5.38118729 14.9653551,8.28118729 C-2.43464494,11.2811873 6.06535506,25.6811873 11.6653551,39.1811873 C17.2653551,52.6811873 16.4653551,57.5811873 33.7653551,50.8811873 Z",
    id: "Oval_00000134962321428899300080000005282761159474398651_",
    fill: "#AB340A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8653551,17.5811873 C58.6653551,25.3811873 2.06535506,53.7811873 10.0653551,67.3811873 C18.0653551,80.9811873 79.5653551,25.1811873 67.7653551,8.88118729 C55.9653551,-7.41881271 -3.53464494,1.68118729 0.165355064,12.5811873 C3.86535506,23.4811873 50.9653551,9.78118729 54.8653551,17.5811873 Z",
    id: "Oval_00000014615440922718147580000002377317460379323777_",
    fill: "#FEEFDE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "face",
    transform: "translate(473.1974, 310)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.202647,177 C144.002647,177 172.102647,157.4 198.802647,140.7 C206.902647,135.6 223.502647,116.5 223.502647,105.6 C223.502647,94.7 208.002647,91.8 208.002647,84.5 C208.002647,38.9 162.502647,0 107.202647,0 C63.4026465,0 33.1026465,10.7 19.6026465,46.1 C18.1026465,49.8 1.3026465,58.8 0.202646503,65.6 C-1.3973535,75.7 7.0026465,88.7 7.0026465,94.4 C7.0026465,140 51.9026465,177 107.202647,177 Z",
    id: "Oval_00000175296469669562045120000013105316143579491243_",
    fill: "#DE6E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8026465,169.9 C118.702647,178.4 168.302647,169.5 175.502647,134.6 C182.702647,99.7 165.802647,77.8 113.802647,72 C110.602647,71.6 103.702647,101.6 91.3026465,107.7 C82.0026465,112.3 66.6026465,93.6 64.2026465,93.6 C58.7026465,93.8 54.7026465,55.9 50.7026465,55.9 C18.8026465,55.9 5.50226398,72 5.50226398,93.6 C5.4026465,121.1 24.9026465,161.4 71.8026465,169.9 Z",
    id: "Oval_00000015327017434662647920000009183646563551862199_",
    fill: "#FEEFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2026465,162.8 C114.002647,162.8 137.702647,157 148.002647,142.3 C154.202647,133.6 152.402647,121.8 152.402647,106 C152.402647,83.4 157.002647,55.8 122.302647,55.8 C99.3026465,55.8 82.1026465,111.1 67.4026465,99.5 C34.4026465,73.4 82.4026465,52.4 56.7026465,41.3 C40.3026465,34.2 10.5026465,77.9 13.7026465,106.1 C17.7026465,140.7 47.1026465,162.8 88.2026465,162.8 Z",
    id: "Oval_00000017505201783769283400000001630895898509183673_",
    fill: "#AB340A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9026465,127.8 C88.7026465,127.8 100.802647,121.7 100.802647,103.5 C100.802647,85.3 91.2026465,65.1 72.9026465,61.4 C54.6026465,57.7 30.2026465,78.5 30.2026465,96.7 C30.2026465,114.9 57.2026465,127.8 72.9026465,127.8 Z",
    id: "Oval_00000000203611810735909170000012716029033375015839_",
    fill: "#FEEFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1026465,24.9 C68.7026465,22.5 76.2026465,24 76.2026465,18.1 C76.2026465,12.2 64.7026465,13.5 53.5026465,15.3 C42.3026465,17.1 33.8026465,25.3 37.6026465,30.9 C41.4026465,36.5 51.4026465,27.2 60.1026465,24.9 Z",
    id: "Oval_00000109711544328458957410000001049373256216470434_",
    fill: "#FEEFDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5026465,87.9 C74.8026465,87.9 79.5026465,84.8 79.5026465,79.9 C79.5026465,75 74.3026465,70.1 66.5026465,68.4 C58.7026465,66.7 51.5026465,72.1 51.5026465,77.1 C51.5026465,82.1 58.2026465,87.9 66.5026465,87.9 Z",
    id: "Oval_00000141418906909294839330000010763379568614818190_",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.602647,55.9 C164.702647,63.7 168.402647,74.7 173.902647,71.6 C179.402647,68.4 174.902647,49.1 169.502647,44.7 C164.102647,40.3 148.302647,31.9 145.502647,40 C142.702647,48.1 152.502647,48.1 158.602647,55.9 Z",
    id: "Oval_00000001659513513082312210000018321530846900100794_",
    fill: "#FEEFDE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_00000160161272894954621070000005686874627653668274_",
    fill: "#232323",
    cx: 125.002647,
    cy: 83,
    rx: 9,
    ry: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0026465,67.4 C44.6026465,68.8 48.9026465,66.5 50.7026465,62.1 C52.5026465,57.7 46.5026465,63.2 42.9026465,61.8 C39.3026465,60.4 39.5026465,52.5 37.7026465,56.9 C35.9026465,61.3 37.4026465,66 41.0026465,67.4 Z",
    id: "Oval_00000090272940079123515660000009050194117451745962_",
    fill: "#232323"
  })), /*#__PURE__*/React.createElement("g", {
    id: "right-ear",
    transform: "translate(635.9405, 316.7486)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.159512,72.55144 C53.259512,68.65144 92.259512,20.15144 88.359512,14.55144 C84.459512,8.85143996 28.359512,11.05144 19.159512,15.25144 C9.959512,19.45144 30.159512,31.45144 35.659512,42.05144 C41.159512,52.65144 45.059512,76.45144 49.159512,72.55144 Z",
    id: "Oval_00000128448342056272217120000017841260632169970821_",
    fill: "#AB340A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.459512,14.55144 C106.359512,14.55144 22.559512,68.65144 41.159512,79.85144 C59.759512,91.05144 115.859512,14.65144 101.759512,5.05143996 C87.659512,-4.54856004 -5.540488,-0.848560036 0.259511997,19.45144 C6.059512,39.75144 44.559512,14.55144 75.459512,14.55144 Z",
    id: "Oval_00000080178072697127240410000015396386914940221835_",
    fill: "#FEEFDE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "right-arm",
    transform: "translate(627.8046, 470.5453)",
    fill: "#DF6B2A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.645803337,32.6005408 C-0.954196663,45.2005408 0.545803337,57.4005408 3.74580334,81.4005408 C4.24580334,85.3005408 4.74580334,88.5005408 6.84580334,92.2005408 C10.3458033,98.3005408 18.9458033,106.600541 29.3458033,104.600541 C37.2458033,103.000541 41.5458033,95.8005408 44.0458033,91.4005408 C49.0458033,82.8005408 48.8458033,74.2005408 48.6458033,65.8005408 C48.4458033,57.6005408 47.2458033,57.5005408 45.5458033,44.1005408 C43.1458033,25.4005408 45.0458033,22.1005408 41.6458033,15.5005408 C40.7458033,13.7005408 33.7458033,-0.0994592201 23.0458033,0 C14.0458033,0.10054078 7.94580334,10.0005408 6.04580334,13.2005408 C4.94580334,15.1005408 2.34580334,19.8005408 0.645803337,32.6005408 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "magnifying",
    transform: "translate(591.8, 369.1131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48,60 L57.8,163.8 C57.9,164.9 57.1,165.9 56,166 C55.9,166 55.9,166 55.8,166 L40.2,166 C39.1,166 38.2,165.1 38.2,164 C38.2,163.9 38.2,163.9 38.2,163.8 L48,60 L48,60 Z",
    id: "Triangle",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_00000137133752554175115250000015539090590089217681_",
    fill: "#525252",
    cx: 47,
    cy: 47,
    r: 47
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_00000043443691625159854890000010894777383584673951_",
    fill: "#EAEAEA",
    cx: 47.4,
    cy: 46.8,
    r: 41.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5,11.9 C74.3,16 85.3,33.7 81.2,51.5 C79.5,59 75.3,65.3 69.8,69.8 C72.8,66 75.1,61.6 76.2,56.5 C80.3,38.7 69.2,21 51.5,16.9 C41.2,14.5 31,17.2 23.4,23.4 C31,13.8 43.7,8.9 56.5,11.9 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "right-hand",
    transform: "translate(617.3504, 446.4)",
    fill: "#6F1703",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6,64.9 C59.5,64.9 63.8,42.3 63.8,25.3 C63.8,8.3 60.8,0 41.9,0 C23,0 0,4.4 0,21.4 C0,38.4 21.8,64.9 40.6,64.9 Z",
    id: "Oval_00000097496948123940544730000007016900108776198047_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lines",
    transform: "translate(393.2816, 269.9992) rotate(-8) translate(-393.2816, -269.9992)translate(224.1316, 120.9992)",
    strokeLinecap: "round",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.7,97.7 C329.8,80.3 333.7,47.7 338.3,-1.42108547e-14",
    id: "Path-3",
    stroke: "#00A2AE",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.7,105.3 C172.9,89.9 159.3,64.6 141,29.3",
    id: "Path-3_00000158008388145092543720000010768442556159481522_",
    stroke: "#00A2AE",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4,217.3 C68,214.2 39.5,211.8 0,210.1",
    id: "Path-3_00000116915737906668641920000006938055969983719602_",
    stroke: "#00A2AE",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.8,
    y1: 74.5,
    x2: 236.8,
    y2: 27.5,
    id: "Path-13",
    stroke: "#007674"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.4,
    y1: 139.8,
    x2: 67.4,
    y2: 111.8,
    id: "Path-13_00000174598777871649355610000004072153881336558994_",
    stroke: "#007674"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77,
    y1: 288,
    x2: 31,
    y2: 298,
    id: "Path-13_00000060029405459455246070000008477098368987034282_",
    stroke: "#007674"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPandaSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/panda-search.8a3b9be33c1e59792e1f1657cb315e6b.svg";